module.exports.PageLinks = {
    about: "about-beals",
    general_enquiry: "contact/general-enquiry",
    news_insight: `about-beals/insights`,
    branch_finder: "contact/branch-finder",
    area_cover: "about-beals/areas-we-cover",
    branch_contact: "contact-us",
    team_contact: "contact-us",
    teams: "contact/meet-the-team",
    request_valuation: "property-valuation",
    privacy_policy: "privacy-policy",
    book_a_viewing: "book-a-viewing",
    book_a_valuation: "property-valuation/home-visit-valuation",
    send_to_friend: "send-to-friend",
    property_to_rent: "property/to-rent",
    property_for_sale: "property/for-sale",
    reviews: "about-beals/reviews",
    landlords: "landlords",
    property_management: "landlords/property-management",
    financial_services: `financial-services`,
    online_payment: "online-payment",
    payment_success: "payment-success",
    payment_failed: "payment-failed",
    payment_verify: "online-payment-verification",
}